var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feature=Deposit, Status=Completed"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3162",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D7E4FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "guest-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.5371 12.2321C29.2673 11.9809 28.909 11.8448 28.5415 11.8448C28.5089 11.8448 28.474 11.8448 28.4415 11.8471C28.4205 11.8495 28.1856 11.8636 27.8181 11.8636C27.2086 11.8636 26.0223 11.8237 24.8988 11.549C23.4449 11.197 21.7701 9.56567 21.2816 9.24411C21.035 9.08215 20.7512 9 20.4674 9C20.186 9 19.9022 9.08215 19.6556 9.24176C19.5975 9.28166 17.8412 11.1312 16.1245 11.549C15.001 11.8213 13.7914 11.8636 13.1843 11.8636C12.8167 11.8636 12.5818 11.8495 12.5608 11.8471C12.5283 11.8448 12.4957 11.8448 12.4631 11.8448C12.0933 11.8448 11.7351 11.9833 11.4629 12.2321C11.1675 12.5043 11 12.8846 11 13.2836V16.8842C11 30.1974 19.8347 31.9132 20.2092 31.9789C20.2953 31.993 20.3814 32 20.4674 32C20.5535 32 20.6419 31.993 20.7256 31.9789C21.1001 31.9108 30 30.1974 30 16.8842V13.2836C30 12.8846 29.8325 12.502 29.5371 12.2321ZM26.227 17.8958L19.7742 24.4092C19.4183 24.7683 18.8391 24.7683 18.4832 24.4092L14.773 20.6631C14.4171 20.304 14.4171 19.7196 14.773 19.3604C15.1289 19.0013 15.7081 19.0013 16.064 19.3604L19.1276 22.454L24.936 16.5931C25.2919 16.234 25.8711 16.234 26.227 16.5931C26.5829 16.9546 26.5829 17.5367 26.227 17.8958Z",
    fill: "url(#paint0_linear_23_8630)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    className: "linear-svg-group",
    id: "paint0_linear_23_8630",
    x1: 20.5,
    y1: 9,
    x2: 20.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-one",
    stopColor: "#385BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-two",
    offset: 1,
    stopColor: "#2148FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositComplete);
export default __webpack_public_path__ + "static/media/deposit-complete.ffa85f54a21c88ba1d3f38f563bad2e5.svg";
export { ForwardRef as ReactComponent };